import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-group-word-card',
  templateUrl: './group-word-card.component.html',
  styleUrls: ['./group-word-card.component.css']
})
export class GroupWordCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
